module.exports = __webpack_public_path__ + "assets/img/none.89b26957.png";